<div
	class="radio-button-solid"
	[style.--radio-active-bg]="activeBgColor"
	[style.--radio-active-border]="activeBorderColor || activeBgColor"
	[style.--radio-active-text]="activeTextColor"
>
	<a
		*ngFor="let button of buttons"
		[routerLink]="!button.disabled ? button.link : null"
		routerLinkActive="current"
		[routerLinkActiveOptions]="{ exact: exact }"
		[attr.aria-disabled]="button.disabled"
		[ngClass]="{ disabled: button.disabled }"
		(click)="button.disabled && $event.preventDefault()"
		>{{ button.label | translate }}</a
	>
</div>
